import { PropsWithChildren, useContext, useEffect, useState, createContext } from 'react';
import useThrowAsyncError from '../../../hooks/useThrowAsyncError';
import { getMedialinksForNode, Medialink } from '../_api/MedialinksApi';
import ModuleContext from './ModuleContext';
import TableOfContentsContext from './TableOfContentsContext';

type MedialinksContextValue = {
  medialinks: Medialink[];
  setMedialinks: React.Dispatch<React.SetStateAction<Medialink[]>>;
};

const MedialinksContext = createContext<MedialinksContextValue>({
  medialinks: [],
  setMedialinks: () => undefined,
});

export default MedialinksContext;

export function MedialinksContextProvider({
  children,
  onlyExercises = false,
}: PropsWithChildren<{ onlyExercises?: boolean }>) {
  const handleError = useThrowAsyncError();

  const { selectedModule } = useContext(ModuleContext);
  const { selectedNode } = useContext(TableOfContentsContext);

  const [medialinks, setMedialinks] = useState<Medialink[]>([]);

  useEffect(() => {
    async function fetchMedialinks() {
      if (!selectedModule || !selectedNode) return;
      try {
        const { data } = await getMedialinksForNode(selectedModule.id, selectedNode.id, true, onlyExercises);

        setMedialinks(data);
      } catch (e) {
        handleError(e);
      }
    }

    fetchMedialinks();
  }, [handleError, onlyExercises, selectedModule, selectedNode]);

  return <MedialinksContext.Provider value={{ medialinks, setMedialinks }}>{children}</MedialinksContext.Provider>;
}
